import { create } from "zustand";
import {
  ILewkGenLimitSlice,
  LewkGenLimitSlice,
} from "./slice/lewk-gen-limit-slice";
import { persist } from "zustand/middleware";

export const useVisitor = create<ILewkGenLimitSlice>()(
  persist(
    (...a) => ({
      ...LewkGenLimitSlice(...a),
    }),
    {
      name: "lewk-gen-limit",
      partialize: (state) => ({
        visitorId: state.visitorId,
        usageCount: state.usageCount,
      }),
      onRehydrateStorage: (state) => {
        return ()=> state.setIsHydrated(true)
      }
    }
  )
);
